import { addressWrapper } from "../Functions";

export class PanToGeoLocation {
  constructor(map, infoWindow) {
    this.map = map;
    this.infoWindow = infoWindow;
    this.browserHasGeolocation = false;
  }

  handleLocationError() {
    this.infoWindow.setPosition(this.map.getCenter());
    this.infoWindow.setContent(
      this.browserHasGeolocation
        ? "Error: The Geolocation service failed."
        : "Error: Your browser doesn't support geolocation."
    );
    this.infoWindow.open(this.map);
  }

  createControl(fillInFormCallback, formPrefix) {
    const button = document.createElement("button");
    button.id = "panToGeoLocationButton";
    button.type = "button";
    button.style.margin = "10px 0 0 10px";
    button.className = "btn btn-light pan-to-location-button";
    button.innerHTML =
      `<svg width="23px" height="23px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">` +
      `<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">` +
      `<g fill="#212121" fill-rule="nonzero">` +
      `<path d="M12,2 C12.3796958,2 12.693491,2.28215388 12.7431534,2.64822944 L12.75,2.75 L12.7490685,4.53770881 L12.7490685,4.53770881 C16.292814,4.88757432 19.1124257,7.70718602 19.4632195,11.2525316 L19.5,11.25 L21.25,11.25 C21.6642136,11.25 22,11.5857864 22,12 C22,12.3796958 21.7178461,12.693491 21.3517706,12.7431534 L21.25,12.75 L19.4616558,12.7490368 L19.4616558,12.7490368 C19.1124257,16.292814 16.292814,19.1124257 12.7474684,19.4632195 L12.75,19.5 L12.75,21.25 C12.75,21.6642136 12.4142136,22 12,22 C11.6203042,22 11.306509,21.7178461 11.2568466,21.3517706 L11.25,21.25 L11.2509632,19.4616558 L11.2509632,19.4616558 C7.70718602,19.1124257 4.88757432,16.292814 4.53678051,12.7474684 L4.5,12.75 L2.75,12.75 C2.33578644,12.75 2,12.4142136 2,12 C2,11.6203042 2.28215388,11.306509 2.64822944,11.2568466 L2.75,11.25 L4.53770881,11.2509315 L4.53770881,11.2509315 C4.88757432,7.70718602 7.70718602,4.88757432 11.2525316,4.53678051 L11.25,4.5 L11.25,2.75 C11.25,2.33578644 11.5857864,2 12,2 Z M12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 Z M12,8 C14.209139,8 16,9.790861 16,12 C16,14.209139 14.209139,16 12,16 C9.790861,16 8,14.209139 8,12 C8,9.790861 9.790861,8 12,8 Z"></path>` +
      `</g>` +
      `</g>` +
      `</svg>`;
    button.title = "Pan to Current Location";
    button.addEventListener("click", () => {
      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };

            this.browserHasGeolocation = true;

            // eslint-disable-next-line no-undef
            new google.maps.Geocoder()
              .geocode({ location: pos })
              .then((response) => {
                if (this.map.getZoom() < 11) {
                  this.map.setZoom(11);
                  this.map.setCenter(pos);
                }
                let place = response.results.find((r) => r.types.includes("street_address"));
                if (!place) {
                  place = response.results.find((r) => r.types.includes("route"));
                }
                if (!place) {
                  place = response.results[0];
                }
                if (place) {
                  this.infoWindow.setContent(
                    addressWrapper(place.formatted_address, fillInFormCallback, place, formPrefix)
                  );
                  this.infoWindow.open(this.map);
                  this.infoWindow.setPosition(pos);
                  this.map.setCenter(pos);
                  return place;
                } else {
                  this.infoWindow.setContent("Nothing found here.");
                  this.infoWindow.open(this.map);
                }
              })
              .catch((e) => window.alert("Geocoder failed due to: " + e));
          },
          () => {
            this.browserHasGeolocation = true;
            this.handleLocationError();
          }
        );
      } else {
        // Browser doesn't support Geolocation
        this.browserHasGeolocation = false;
        this.handleLocationError();
      }
    });

    // eslint-disable-next-line no-undef
    this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(button);
  }
}
